/**
 * Definition of HTTP errors returned from function calls
 */
export var HTTP_ERROR_STATUS;
(function (HTTP_ERROR_STATUS) {
  HTTP_ERROR_STATUS["PERMISSION_DENIED"] = "permission-denied";
  HTTP_ERROR_STATUS["INTERNAL"] = "internal";
  HTTP_ERROR_STATUS["INVALID_ARGUEMENT"] = "invalid_arguement";
})(HTTP_ERROR_STATUS || (HTTP_ERROR_STATUS = {}));